<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                <div class="row justify-content-center">
                    <div>
                        <p class="h2 page-title">Member Status, Plan & Benefits, Access to Hospital</p>
                    </div>
                </div>
                
                <div class="row justify-content-center phil-row-info">
                    <div class="col-12">
                        
                     <div v-html="StatusHTML" class="list-unstyled custom-column"></div>
                      </div>
                </div>

                <div class="row justify-content-center phil-row-info">
                    <div class="col-6">
                        <p><strong><em>Plan Packages</em></strong></p>
                     <div v-html="PlanBenefitsHTML" class="list-unstyled custom-column scroll" style="overflow:auto; height:209px;"></div>
                      </div>
                      <div class="col-6">
                        <p><strong><em>Membership Information</em></strong></p>
                         <div v-html="ProviderAccessHTML" class="list-unstyled custom-column"></div>
                      </div>
                </div>
            
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <router-link to="/member-page"><a type="button" class="btn btn-primary btn-lg" style="margin-top: 25px;">BACK</a></router-link>
                </div>
            </div>
        </div>
        </section>
        <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
</body>
</template>


<script>
import axios from 'axios';
export default {
  name: 'PhilLogin',
  data() {
    return {
      certNo: '',
      TokenID: '',
      PlanBenefitsHTML:'',
      ProviderAccessHTML:'',
      StatusHTML:'',
      error: false,
      loading: false
    }
  },
    async created() {
      this.loading = true
      this.TokenID = localStorage.getItem('TokenID')
      console.log(this.TokenID)
      this.certNo = localStorage.getItem('CertNo')
        
        
        const response = await axios.post('/api/?action=member-status', {
           TokenID: this.TokenID,
           CertNo: this.certNo
           
        }, 
        );
        this.loading = false
        if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
        console.log(response);
        this.PlanBenefitsHTML=response.data.PlanBenefitsHTML;
        this.ProviderAccessHTML=response.data.ProviderAccessHTML;
        this.StatusHTML=response.data.StatusHTML;
        
    }
  }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
